'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _PublicAvatar = require('./PublicAvatar');

var _PublicAvatar2 = _interopRequireDefault(_PublicAvatar);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  currentRole: _SenderTypePropType2.default.isRequired,
  isLastInGroup: _react.PropTypes.bool,
  messageRole: _SenderTypePropType2.default.isRequired,
  responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')]),
  tooltipPlacement: _react.PropTypes.string
};

var ChatMessageAvatar = function (_Component) {
  _inherits(ChatMessageAvatar, _Component);

  function ChatMessageAvatar() {
    _classCallCheck(this, ChatMessageAvatar);

    return _possibleConstructorReturn(this, (ChatMessageAvatar.__proto__ || Object.getPrototypeOf(ChatMessageAvatar)).apply(this, arguments));
  }

  _createClass(ChatMessageAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          messageRole = _props.messageRole,
          currentRole = _props.currentRole,
          responder = _props.responder,
          isLastInGroup = _props.isLastInGroup,
          tooltipPlacement = _props.tooltipPlacement;


      if (currentRole === _senderTypes.AGENT) {
        return _react2.default.createElement(_Avatar2.default, {
          responder: responder,
          size: 'extra-small',
          isLastInGroup: isLastInGroup,
          showNameTooltip: true,
          tooltipPlacement: tooltipPlacement
        });
      }

      return _react2.default.createElement(_PublicAvatar2.default, {
        responder: responder,
        messageRole: messageRole,
        isLastInGroup: isLastInGroup
      });
    }
  }]);

  return ChatMessageAvatar;
}(_react.Component);

ChatMessageAvatar.propTypes = propTypes;

exports.default = ChatMessageAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/ChatMessageAvatar.js
// module id = 1132
// module chunks = 2 3